import React, { FC } from 'react';
import { StyledLabel } from './Styles';

const RequiredLabel: FC = () => <StyledLabel>*Required</StyledLabel>;

export default RequiredLabel;
